import { useAppSelector } from 'js/store/hooks';

export function useAuthState() {
  return useAppSelector(state => state.auth);
}
